<!--
 * @Author: zyy
 * @Date: 2022-12-01 13:37:03
 * @LastEditors: zyy
 * @LastEditTime: 2022-12-01 17:41:52
 * @Description: default
-->
<template>
    <div class="payment-record" :class="{ 'app-region blank-t-v blank-l-h blank-r-h': !communityId }">
        <a-row type="flex" align="bottom" :gutter="[16, 16]" class="mg-normal">
            <a-col :span="24" :xl="8">
                <a-row :gutter="[8, 8]">
                    <a-col>
                        <p>车牌号码</p>
                    </a-col>
                    <a-col>
                        <a-input v-model="table.search.car_no" placeholder="请输入车牌号码" allow-clear></a-input>
                    </a-col>
                </a-row>
            </a-col>

            <a-col :span="24" :xl="8">
                <a-row :gutter="[8, 8]">
                    <a-col>
                        <p>查询时间</p>
                    </a-col>
                    <a-col>
                        <a-range-picker v-model="table.search.time" class="app-block" show-time
                            :valueFormat="dateFormat" :format="dateFormat"></a-range-picker>
                    </a-col>
                </a-row>
            </a-col>

            <a-col :span="24" :xl="8">
                <a-space>
                    <a-button type="primary" @click="searchTable">查询</a-button>
                    <a-button @click="resetSearchTable">重置</a-button>
                </a-space>
            </a-col>
        </a-row>
        <a-table class="mg-normal" :loading="table.loading" :columns="table.columns" :data-source="table.data"
            rowKey="id" :pagination="table.page" @change="handlePageChange" @expand="getInfo"
            :expandIcon="customExpandIcon">
            <template slot="expandedRowRender" slot-scope="record">
                <div class="box">
                    <div class="flex">
                        <span style="width: 400px;">入场车道:{{ record.inPassagewayName }}</span>
                        <div class="flex" v-viewer>入场照片:
                            <img :src="table.info.inImage" style="margin:5px;cursor: pointer;" v-if="table.info.inImage"
                                width="40" height="40">
                            <img :src="table.info.inImage2" style="margin:5px;cursor: pointer;"
                                v-if="table.info.inImage2" width="40" height="40">
                        </div>
                    </div>
                    <div class="flex" style="margin:10px 10px 0 0">
                        <span style="width: 400px;">离场车道:{{ record.outPassagewayName }}</span>
                        <div class="flex" v-viewer>离场照片:
                            <img :src="table.info.outImage" style="margin:5px;cursor: pointer;"
                                v-if="table.info.outImage" width="40" height="40">
                            <img :src="table.info.outImage2" style="margin:5px;cursor: pointer;"
                                v-if="table.info.outImage2" width="40" height="40">
                        </div>
                    </div>
                </div>
            </template>
        </a-table>
    </div>
</template>
  
<script>
import OutInLogService from '@/io/park/outinLog.js';

export default {
    name: 'PaymentRecord',
    props: {
        communityId: {
            type: Number,
            default: null
        },
    },
    data() {
        let self = this;
        return {
            dateFormat: 'YYYY-MM-DD HH:mm:ss',
            table: {
                loading: false,
                info: {},
                search: {
                    number: null,
                    status: [],
                    time: [],
                },
                page: {
                    total: 0,
                    current: 1,
                    pageSize: 10,
                    showQuickJumper: true,
                    showSizeChanger: true,
                    showTotal() {
                        return `共${self.table.page.total}条`;
                    }
                },
                data: [],
                columns: [
                    {
                        title: '车牌号码',
                        customRender: text => text.plate ? text.plate : text.inAutoPlate
                    },
                    {
                        title: '车牌颜色',
                        dataIndex: 'plateColor'
                    },
                    {
                        title: '入场时间',
                        dataIndex: 'inTime'
                    },
                    {
                        title: '离场时间',
                        dataIndex: 'outTime'
                    },
                    {
                        title: '停车时长',
                        customRender: text => `${text.parkingTime / 60}分钟`
                    },
                    {
                        title: '应收金额',
                        dataIndex: 'payableAmount'
                    },
                    {
                        title: '实收金额',
                        dataIndex: 'paidAmount'
                    }
                ]
            }
        }
    },
    watch: {
        communityId: {
            handler(newValue, oldValue) {
                if (newValue || this.$getCookie('communityId')) {
                    this.searchTable();
                }
            },
            immediate: true
        }
    },
    activated() {
        if (this.communityId) {
            this.initData();
        }
        this.table.search.time = [
            this.$dateFormat(this.dateFormat, new Date(new Date(new Date().toLocaleDateString()).getTime())),
            this.$dateFormat(this.dateFormat, new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1))]
    },
    methods: {
        customExpandIcon(props) {
            console.log(props,'$$')
            if (props.record) {
                if (props.expanded) {
                    return (
                        <a-icon
                        size="32"
                            style="color: rgba(0,0,0,0.4);padding:10px 5px;box-sizing:border-box;font-size:20px"
                            type="minus-square"
                            onClick={(e) => {
                                props.onExpand(props.record, e);
                            }}
                        />
                    );
                } else {
                    return (
                        <a-icon
                            style="color: rgba(0,0,0,0.4);padding:10px 5px;box-sizing:border-box;font-size:20px"
                            type="plus-square"
                            onClick={(e) => {
                                props.onExpand(props.record, e);
                            }}
                        />
                    );
                }
            } else {
                return <span></span>;
            }
        },


        getInfo(expanded, record) {
            OutInLogService.info({
                community_id: this.communityId,
                code: record.inVoucherCode
            }).then(res => {
                this.table.info = res
            })
        },
        searchTable() {
            this.table.page.current = 1;
            this.initData();
        },
        resetSearchTable() {
            this.table.search = {
                number: null,
                status: [],
                time: []
            };
            this.searchTable();
        },
        handlePageChange(page) {
            this.table.page.current = page.current;
            this.table.page.pageSize = page.pageSize;
            this.initData();
        },
        initData() {
            this.table.loading = true;
            return OutInLogService.list(
                this.communityId,
                this.table.search.car_no,
                this.table.search.time[0],
                this.table.search.time[1],
                this.table.page.current,
                this.table.page.pageSize
            ).then(res => {
                this.table.page.total = res.totalRows;
                this.table.data = res.pageData
            }).catch(err => { }).finally(() => {
                this.table.loading = false;
            });
        },
    },
}
</script>
  
<style lang="less" scoped>
.flex {
    display: flex;
}

.box {
    color: #898989;
}
</style>